module.exports = __webpack_public_path__ + "img/019-work-station.4322606d.svg";